import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import classNames from 'classnames';
import { t } from 'ttag';

import Search from '@svg/search.svg';
import { FILTER_QUERIES } from '@constants';
import { Input } from '@ui/Input';
import { SelectOption } from '@ui/Select';
import { HeaderCatalogSelect } from '@components/HeaderCatalogSelect';
import { matchCatalogPath, matchCollectionPath } from '@utils/common';
import { sendSearchApplyEvent, sendSearchOpenEvent } from '@utils/analytics';

import s from './HeaderSearch.sss';

type CatalogOption = SelectOption<string>;

interface Props {
  selectedCatalog: CatalogOption,
  catalogsOptions: CatalogOption[]
  className?: string,
  isMobile?: boolean,
  onSelectCatalog: (option: CatalogOption) => void,
  onSubmit: (e: React.FormEvent) => void,
}

export const HeaderSearch: React.FC<Props> = ({
  selectedCatalog,
  catalogsOptions,
  className,
  isMobile,
  onSelectCatalog,
  onSubmit,
}) => {
  const location = useLocation();
  const history = useHistory();
  const [searchValue, setSearchValue] = useState(() => {
    const search = queryString.parse(location.search);
    return search[FILTER_QUERIES.SEARCH_TEXT] as string || undefined;
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const collectionMatch = matchCollectionPath(selectedCatalog.value);
    const catalogMatch = matchCatalogPath(selectedCatalog.value);

    sendSearchApplyEvent({
      namespace: catalogMatch ? catalogMatch.params.namespace : undefined,
      categorySlug: catalogMatch && 'slug' in catalogMatch?.params ? catalogMatch?.params.slug : undefined,
      collection: collectionMatch ? collectionMatch.params.slug : undefined,
    });

    onSubmit(e);
  };

  const submitUrl = history.createHref({
    pathname: selectedCatalog.value.startsWith('/')
      ? selectedCatalog.value
      : `/${selectedCatalog.value}`,
  });

  return (
    <div className={classNames(s.root, className)}>
      <HeaderCatalogSelect
        className={s.catalogSelect}
        options={catalogsOptions}
        value={selectedCatalog}
        onChange={onSelectCatalog}
      />
      <form
        className={s.form}
        action={submitUrl}
        method="GET"
        onSubmit={handleSubmit}
      >
        <Input
          className={s.inputHolder}
          inputClassName={s.input}
          theme="transparent"
          placeholder={t`Я хочу купити на SHAFA ...`}
          name={FILTER_QUERIES.SEARCH_TEXT}
          autoFocus={isMobile}
          value={searchValue}
          onChange={handleInputChange}
          onFocus={sendSearchOpenEvent}
        />
        <button
          className={s.submit}
          type="submit"
        >
          <Search
            className={s.icon}
            width="24"
            height="24"
          />
        </button>
      </form>
    </div>
  );
};
